<!--
	its frontend

	Menu, submodule from App

    @file         Page_menu.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


<script>

    import { PAGE }                             from './config';
    import { readVersion, stopClickPropagation }    from './minions';
    import { SunIcon, ApertureIcon, AwardIcon, HomeIcon,
             XCircleIcon, LogOutIcon}           from 'svelte-feather-icons';


    import {createEventDispatcher}              from "svelte";
    let dispatch =  createEventDispatcher();

    let versionStr = 'v0.0.0'

    
// =================================== Login =================================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
        login = value;
    });



// ============================ Exit Application =============================


    const quitApp = ()=> {
        window.close();
    };//quitApp()



// ========================== Construction / Init ============================


    import { onMount } from 'svelte';

    onMount(async () => {
        versionStr = await readVersion();
    });//onMount()


    // Close this modeal and inform main app which desk page to display
    const close = (nextPage)=> {
        dispatch('close', {page: nextPage});
    };//close()

</script>



<!-- =============================  H T M L  ============================= -->



<div class="modal" on:click={close}>

    <div class="details-backBtn">
        <XCircleIcon size="3x" />
    </div>

    <div id="version">
        {versionStr}
    </div>

    <div class="modal-frame" on:click={stopClickPropagation}>

        <div id="btnlist">

            <button class="btn" on:click={()=>close(PAGE.home)}>
                <HomeIcon size="0.8x"/> Home
            </button>

            <button class="btn" on:click={()=>close(PAGE.liPro)}>
                <SunIcon size="0.8x"/> Illumination
            </button>

            <button class="btn" on:click={()=>close(PAGE.liProLight)}>
                <SunIcon size="0.8x"/> Illum. Quick Test
            </button>

            {#if login.level >= 100}
            <button class="btn" on:click={()=>close(PAGE.camTe)}>
                <ApertureIcon size="0.8x"/> Camera
            </button>
            {/if}
        
            <button class="btn" on:click={()=>close(PAGE.benMa)}>
                <AwardIcon size="0.8x"/>  Benchmark
            </button>

            <button class="btn" on:click={quitApp}>
                <LogOutIcon /> Quit App
            </button>
        </div>

    </div>


</div>


<!-- ============================  S T Y L E  ============================ -->



<style>
    .details-backBtn {
        color: var(--PG-blue);
        position: absolute;
        top: 4%;
        left: 5%;
    }

    #version{
        position: absolute;
        top: 6%;
        right: 10%;
        font-size: 0.8em;
        color: #444;
    }

    #btnlist {
        height: 100%;
        width: 60%;
        margin: auto;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
    }

    #btnlist .btn{
        font-size: 1.5em;
        width: 100%;
        margin: auto;
        /* background-color: white; */
        /* border-radius: 4px; */
        border: none;
        padding: 0.5em;
    }

</style>